import React, { useEffect, useState } from "react";
import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Loader } from "../components/ui/loader/loader";
import { Layout } from "../pages/layout/layout";
const ViewEntryData = lazy(() => import("../pages/forms/viewEntryData"));
const AddSubProgram = lazy(() => import("../pages/forms/addSubProgram"));
const AddSubProgramFields = lazy(() =>
  import("../pages/forms/addSubProgramField")
);
const AddSurveyAnalytics = lazy(() =>
  import("../pages/forms/addSurveyAnalytics")
);
const AddRecords = lazy(() => import("../pages/forms/addRecords"));
const AddBenRecords = lazy(() => import("../pages/forms/addBenRecords"));
const EventData = lazy(() => import("../pages/forms/eventData"));
const AddRFPdata = lazy(() => import("../pages/forms/addRFPdata"));
const AddRFQData = lazy(() => import("../pages/forms/addRfq"));
const SurveyForm = lazy(() => import("../pages/forms/SurveyForm"));
const ResetPassword = lazy(() => import("../pages/forms/resetPassword"));
const AddModalHeader = lazy(() => import("../pages/forms/addModalHeader"));
const AddHouseServeyField = lazy(() =>
  import("../pages/forms/addHouseServeyField")
);
const AddHouseServeyData = lazy(() =>
  import("../pages/forms/addHouseServeyData")
);
const ViewHouseSurveyData = lazy(() =>
  import("../pages/forms/viewHouseSurveyData")
);
const UserList = lazy(() => import("../pages/forms/userList"));
const AddSurvey = lazy(() => import("../pages/forms/addSurvey"));
const AddActionPlanManagement = lazy(() =>
  import("../pages/forms/addActionPlanManagement")
);
const ProjectTracker = lazy(() => import("../pages/forms/projectTracker"));
const ProjectDetails = lazy(() => import("../pages/forms/projectDetails"));
const CreateMilestone = lazy(() => import("../pages/forms/createMilestone"));
const AddProgramAnalytics = lazy(() =>
  import("../pages/forms/addProgramAnalytics")
);
const DynamicAnalytics = lazy(() =>
  import("../pages/forms/dynamicAnalytics")
);
const AddProgramFields = lazy(() => import("../pages/forms/addProgramField"));
const AddProgramData = lazy(() => import("../pages/forms/addProgramsData"));
const AddUser = lazy(() => import("../pages/forms/addUsers"));
const Dashboard = lazy(() => import("../pages/dashboard/dashboard"));
const AddProject = lazy(() => import("../pages/forms/addProjects"));
const AddProgram = lazy(() => import("../pages/forms/addPrograms"));
const AddModalType = lazy(() => import("../pages/forms/addModalType"));
const DataExporter = lazy(() => import("../pages/forms/DataExporter"));
const Login = lazy(() => import("../pages/login/login"));
const BulkData = lazy(() => import("../pages/bulkData/BulkData"));
const DynamicCharts = lazy(() => import("../pages/forms/dynamicCharts"));
const ActivityAnalysis = lazy(() =>
  import("../pages/forms/ActivityAnalysis")
);
const ThematicDashboard = lazy(() =>
  import("../pages/dashboard/ThematicDashboard")
);

const AppRoutes = () => {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
    setRole(storedRole); // triggers re-render
  }, []);

  // const role = localStorage.getItem("userRole")?.trim();
  const routeList = [
    {
      path: "/",
      element: <Login />,
      exact: true,
      layout: false,
    },
    {
      path: "/login",
      element: <Login />,
      exact: true,
      layout: false,
    },
    // role && role !== "User" && {
    //   path: "/dashboard",
    //   element: <Dashboard />,
    //   exact: true,
    //   layout: true,
    // },

    ...(role !== "User"
      ? [
        {
          path: "/dashboard",
          element: <Dashboard />,
          layout: true,
        },
      ]
      : []),

    {
      path: "/add-beneficiary-data",
      element: <AddProgramData />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-fields",
      element: <AddProgramFields />,
      exact: true,
      layout: true,
    },
    {
      path: "/addproject",
      element: <AddProject />,
      exact: true,
      layout: true,
    },
    {
      path: "/addprogram",
      element: <AddProgram />,
      exact: true,
      layout: true,
    },
    {
      path: "/adduser",
      element: <AddUser />,
      exact: true,
      layout: true,
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-analytics",
      element: <AddProgramAnalytics />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-survey-analytics",
      element: <AddSurveyAnalytics />,
      exact: true,
      layout: true,
    },
    {
      path: "/view-entry-data",
      element: <ViewEntryData />,
      exact: true,
      layout: true,
    },
    {
      path: "/events",
      element: <EventData />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-sub-program",
      element: <AddSubProgram />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-subprogram-fields",
      element: <AddSubProgramFields />,
      exact: true,
      layout: true,
    },
    {
      path: "/view-entry-data/add-record",
      element: <AddRecords />,
      exact: true,
      layout: true,
    },
    {
      path: "/user-list",
      element: <UserList />,
      exact: true,
      layout: true,
    },
    {
      path: "/view-entry-data/add-ben-record",
      element: <AddBenRecords />,
      exact: true,
      layout: true,
    },
    // {
    //   path: "/add-rfp-fields",
    //   element: <AddRFPfield />,
    //   exact: true,
    //   layout: true,
    // },
    {
      path: "/add-rfp-data",
      element: <AddRFPdata />,
      exact: true,
      layout: true,
    },
    //    {
    //   path: "/view-rfp-data",
    //   element: <ViewRFPData />,
    //   exact: true,
    //   layout: true,
    // },
    {
      path: "/rfq-data",
      element: <AddRFQData />,
      exact: true,
      layout: true,
    },
    {
      path: "/survey-form",
      element: <SurveyForm />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-modal-header",
      element: <AddModalHeader />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-survey-fields",
      element: <AddHouseServeyField />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-survey-data",
      element: <AddHouseServeyData />,
      exact: true,
      layout: true,
    },
    {
      path: "/view-survey-data",
      element: <ViewHouseSurveyData />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-survey",
      element: <AddSurvey />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-action-plan-management",
      element: <AddActionPlanManagement />,
      exact: true,
      layout: true,
    },
    {
      path: "/project-tracker",
      element: <ProjectTracker />,
      exact: true,
      layout: true,
    },
    {
      path: "/project-tracker/project-details",
      element: <ProjectDetails />,
      exact: true,
      layout: true,
    },
    {
      path: "/project-tracker/create-milestone",
      element: <CreateMilestone />,
      exact: true,
      layout: true,
    },
    {
      path: "/add-modal-Type",
      element: <AddModalType />,
      exact: true,
      layout: true,
    },
    {
      path: "/export-data",
      element: <DataExporter />,
      exact: true,
      layout: true,
    },
    {
      path: "/bulk-data",
      element: <BulkData />,
      exact: true,
      layout: true,
    },
    {
      path: "/dynamic-analytics",
      element: <DynamicAnalytics />,
      exact: true,
      layout: true,
    },
    {
      path: "/view-dynamic-analytics",
      element: <DynamicAnalytics />,
      exact: true,
      layout: true,
    },
    {
      path: "/dynamic-charts",
      element: <DynamicCharts />,
      exact: true,
      layout: true,
    },
    {
      path: "/activity-analysis",
      element: <ActivityAnalysis />,
      exact: true,
      layout: true,
    },
    {
      path: "/thematic-dashboard",
      element: <ThematicDashboard />,
      exact: true,
      layout: true,
    },
  ];

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {routeList?.map(({ path, element, layout }) => (
          <Route
            key={path}
            path={path}
            element={layout ? <Layout>{element}</Layout> : element}
          />
        ))}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
